<template>
  <div class="wrapper">
    <div class="animated fadeIn ">
      <b-row>
        <b-col cols="12">
         <b-breadcrumb :items="breadcrumbs"/>         
          <b-card header-tag="header" footer-tag="footer" style=" margin-bottom: 0px;">       
            <!-- {{ shipmentcount }}   -->
            <b-row class="boxto">  
               <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.pending_picking > 0 ? 'pointer' : 'default' }" >
                <b-card no-body class="bg-pink">
                  <b-card-body class="pb-0">  
                     <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          // query: { keyword: shipmentname.pending_picking },
                           query: { keyword: shipmentname.pending_picking }
                        }"
                      >        
     
                    <h4 class="mb-0 display-3 text-center" id="pickupassigned" v-b-tooltip.hover title="Pending Picking">{{ shipmentcount.pending_picking || 0}}</h4>
                    <p class="text-center countcolor"  v-b-tooltip.hover title="Pending Picking">Pending Picking</p>
                    </router-link>
                   
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.Pending_awbprint > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-aqua">
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_awbprint },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="pickupassigned" v-b-tooltip.hover title="Pending AWB">{{ shipmentcount.Pending_awbprint || 0 }}</h4>
                    <p class="text-center countcolor"  v-b-tooltip.hover title="Pending AWB">Pending AWB</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.Pending_allocation > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-def" >
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_allocation },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" v-b-tooltip.hover title="Pending allocation " id="pickuppending">{{ shipmentcount.Pending_allocation || 0 }}</h4>
                    <p class="text-center countcolor" v-b-tooltip.hover title="Pending allocation ">Pending allocation </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
               <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.Pending_ofd > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-green">
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_ofd },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="totalrto" v-b-tooltip.hover title="Pending OFD">{{ shipmentcount.Pending_ofd || 0 }}</h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Pending OFD">Pending OFD </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>   
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.Pending_rvp_allocation > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-pink">
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_rvp_allocation },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="deliverypending" v-b-tooltip.hover title="Pending RVP allocation">{{ shipmentcount.Pending_rvp_allocation || 0 }}</h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Pending RVP allocation">Pending RVP allocation</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.Pending_rvp_receiving > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-purpal">
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_rvp_receiving },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="delivered" v-b-tooltip.hover title="Pending RVP receiving ">{{ shipmentcount.Pending_rvp_receiving || 0 }}</h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Pending RVP receiving ">Pending RVP receiving </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
             
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.Pending_ndr_receiving > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-red">
                  <b-card-body class="pb-0" >          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_ndr_receiving },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="ndr" v-b-tooltip.hover title="Pending NRD receiving ">{{ shipmentcount.Pending_ndr_receiving || 0 }}</h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Pending NRD receiving ">Pending NRD receiving </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
            </b-row>
           
          </b-card>
          <hr />

          <b-card header-tag="header" footer-tag="footer" style=" margin-bottom: 0px;">         
            <b-row class="boxto">  
               <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.total_allocated > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-pink">
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_allocated },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="pickupassigned" v-b-tooltip.hover title="Total Allocated ">{{ shipmentcount.total_allocated || 0 }}</h4>
                   <p class="text-center countcolor"  v-b-tooltip.hover title="Total Allocated ">Total Allocated </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.total_delivered > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-aqua">
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_delivered },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="pickupassigned" v-b-tooltip.hover title="Total Deliverd">{{ shipmentcount.total_delivered || 0 }}</h4>
                    <p class="text-center countcolor"  v-b-tooltip.hover title="Total Deliverd">Total Deliverd</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.total_ndr > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-def" >
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_ndr },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" v-b-tooltip.hover title="Total NDR" id="pickuppending">{{ shipmentcount.total_ndr || 0 }}</h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Total NDR">Total NDR</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
               <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.total_rto > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-green">
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_rto },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="totalrto" v-b-tooltip.hover title="Total RTO">{{ shipmentcount.total_rto || 0 }}</h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Total RTO">Total RTO </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>   
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.total_ofd > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-pink">
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_ofd },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="deliverypending" v-b-tooltip.hover title="Total OFD">{{ shipmentcount.total_ofd || 0 }}</h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Total OFD">Total OFD</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.total_rvp_allocation > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-purpal">
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_rvp_allocation },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="delivered" v-b-tooltip.hover title="Total RVP Allocated">{{ shipmentcount.total_rvp_allocation || 0 }}</h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Total RVP Allocated">Total RVP Allocated</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
             
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.total_rvp_pickup > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-red">
                  <b-card-body class="pb-0" >          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_rvp_pickup },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="ndr" v-b-tooltip.hover title="RVP PIC UP ">{{ shipmentcount.total_rvp_pickup || 0 }}</h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="RVP PIC UP ">RVP PICK UP </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.total_rvp_cancalled > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-green">
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_rvp_cancalled },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="totalrto" v-b-tooltip.hover title="RVP cancelled">{{ shipmentcount.total_rvp_cancalled || 0 }}</h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="RVP cancelled">RVP cancelled </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>   
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.total_rvp_handover > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-pink">
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_rvp_handover },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="deliverypending" v-b-tooltip.hover title="RVP Handover ">{{ shipmentcount.total_rvp_handover || 0 }}</h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="RVP Handover ">RVP Handover </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.total_picked > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-purpal">
                  <b-card-body class="pb-0">          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_picked },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="delivered" v-b-tooltip.hover title="Total Picked">{{ shipmentcount.total_picked || 0 }}</h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Total Picked">Total Picked</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
             
              <b-col sm="6" lg="2" :style="{ cursor: shipmentcount.total_packed > 0 ? 'pointer' : 'default' }">
                <b-card no-body class="bg-red">
                  <b-card-body class="pb-0" >          
                      <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_packed },
                        }"
                      >        
                    <h4 class="mb-0 display-3 text-center" id="ndr" v-b-tooltip.hover title="Total packed ">{{ shipmentcount.total_packed || 0 }}</h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Total packed ">Total packed </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
            </b-row>
           
          </b-card>
        </b-col>
      </b-row>
  </div>
</div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";

export default {
  data: function () {
    return {
      name: 'dashboard',
       breadcrumbs: [{
        text: 'Quick User Dashboard',
        active: true
      }],
      pickuplocationmasterid:'',
      shipmentcount:{},
      shipmentname:{},
    }
  },
  components: {
   
    userInfo: []
  },
  created: function () {
    this.qwikdashboardcountforqwikshipments()
  },
  methods: {
    
    qwikdashboardcountforqwikshipments(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.pickuplocationmasterid = userInfo.pickuplocationmasterid;
           const obj = {
          hub_id: `${userInfo.pickuplocationmasterid}`,
        };

        this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/qwikdashboardcountforqwikshipments`,
            obj
          )
          .then((result) => {
            if(result.body.returnmsg == 'Successful'){
             
            this.shipmentcount = result.body.returnvalue.reduce((obj, item) => {
              obj[item.shipment_status] = item.shipment_count;
              return obj;
            }, {});

            this.shipmentname = result.body.returnvalue.reduce((obj, item) => {
              obj[item.shipment_status] = item.shipment_status;
              return obj;
            }, {});
            

            }
            else{
              this.shipmentcount = []
            }
          })
        
    }
  }
};
</script>

<style>
.bg-aqua{
      background-color: #00c0ef !important;
      color: #fff!important;
}
.bg-green{
      background-color: #00a65a !important;
       color: #fff!important;
}
.bg-yellow{
      background-color: #f39c12 !important;
       color: #fff!important;
}
.bg-pink{
  background-color: #FF69B4 !important;
   color: #fff!important;
}
.bg-purpal{  
    background-color: #9370DB !important;
     color: #fff!important;
}
.bg-cyan{
      background-color: #008B8B !important;
       color: #fff!important;  
}
.bg-red{
      background-color: #dd4b39 !important;
       color: #fff!important;
}
.bg-def{
  background-color: #f09642 !important;
   color: #fff!important;
  
}
.boxto .card-body{
  padding: 0px!important;
}
.countcolor
{
      color:white !important;

}
.display-3 
{
      font-size: 3.5rem !important;
}

</style>